import { createContext } from 'react'
import { TranslationFn } from './types'

export interface I18nContextType {
  locale: string
  loadingTranslations: boolean
  translationsUnavailable: boolean
  setLocale: (locale: string) => void
  t: TranslationFn
}

const I18nContext = createContext<I18nContextType | null>(null)

export default I18nContext
